import { BUTTON_CELL_DISPLAY_NAME } from "./core";
import createDisplayName from "../../../../fabrics/createDisplayName";

export const createDisplayNameForButtonCellElement = createDisplayName(
    BUTTON_CELL_DISPLAY_NAME,
);
